import { useQuery } from '@tanstack/react-query';
import { jobPositionService } from '../services/jobPosition.service';
import type { JobPosition } from '../types/jobPosition.types';

interface UseJobPositionsReturn {
  jobPositions: JobPosition[];
  hasData: boolean;
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
  refetch: () => void;
}

export function useJobPositions(): UseJobPositionsReturn {
  const query = useQuery({
    queryKey: ['job-positions'],
    queryFn: () => jobPositionService.list(),
  });

  return {
    jobPositions: query.data ?? [],
    hasData: query.data !== undefined,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
}
